module.exports = __webpack_public_path__ + "img/unwire-20230904.604ee409.jpg";